import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  loginSchema,
  loginResponseSchema,
  registerSchema,
  registerResponseSchema,
  refreshTokenSchema,
  refreshTokenResponseSchema,
  createApiKeySchema,
  apiKeyResponseSchema,
  apiKeyListItemSchema,
  changePasswordSchema,
} from '../schemas/auth.schemas';
import { errorResponseSchema, successResponseSchema } from '../schemas/common.schemas';

const c = initContract();

export const authContract = c.router({
  login: {
    method: 'POST',
    path: '/auth/login',
    body: loginSchema,
    responses: {
      200: loginResponseSchema,
      401: errorResponseSchema,
      400: errorResponseSchema,
    },
    summary: 'Login with email and password',
  },
  register: {
    method: 'POST',
    path: '/auth/register',
    body: registerSchema,
    responses: {
      201: registerResponseSchema,
      400: errorResponseSchema,
      409: errorResponseSchema,
    },
    summary: 'Register a new organization and admin user',
  },
  refreshToken: {
    method: 'POST',
    path: '/auth/refresh',
    body: refreshTokenSchema,
    responses: {
      200: refreshTokenResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Refresh access token',
  },
  changePassword: {
    method: 'POST',
    path: '/auth/change-password',
    body: changePasswordSchema,
    responses: {
      200: successResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Change user password',
  },
  // API Key Management
  createApiKey: {
    method: 'POST',
    path: '/auth/api-keys',
    body: createApiKeySchema,
    responses: {
      201: apiKeyResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Create a new API key',
  },
  listApiKeys: {
    method: 'GET',
    path: '/auth/api-keys',
    responses: {
      200: z.object({
        apiKeys: z.array(apiKeyListItemSchema),
      }),
      401: errorResponseSchema,
    },
    summary: 'List all API keys',
  },
  deleteApiKey: {
    method: 'DELETE',
    path: '/auth/api-keys/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: z.object({}),
    responses: {
      200: successResponseSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Delete an API key',
  },
  createPublicApiKey: {
    method: 'POST',
    path: '/auth/public-api-keys',
    body: z.object({
      name: z.string().min(1).max(100).optional(),
    }),
    responses: {
      201: apiKeyResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Create a public API key for frontend SDK',
  },
});
